export default __webpack_public_path__ + "static/media/IMG_2909.be38f6fd.JPG";